var exports = {
  "V0": "miniHeaderInner__PNUGO_",
  "DD": "title__rbH5Fa",
  "ai": "number__psmPBx",
  "yu": "metadata__jEOHXh",
  "o1": "actions__tWsgi0",
  "KT": "squareButton__tLdeZ3",
  "Os": "hideLgPlus__nRDt9x",
};

module.exports = exports;
